<template>
    <li :class="[{active: isActive}]">
        <div
            class="head"
            @click="toggleActive"
        >
            <div
                data-toggler
                class="data-toggler"
            >
                <span class="title">{{ title }}</span>
                <y-icon
                    v-if="isActive"
                    :icon="openIcon"
                    color="font"
                    size="small"
                />
                <y-icon
                    v-else
                    :icon="closeIcon"
                    color="font"
                    size="small"
                />
            </div>
        </div>

        <slide-up-down :active="isActive">
            <div class="body">
                <!--
                @slot Content of the accordion item
                    @binding none
                -->
                <slot />
            </div>
        </slide-up-down>
    </li>
</template>

<script>
    import SlideUpDown from 'vue-slide-up-down';
    import { YIcon } from '@components/Icon';

    export default {
        name: 'AccordionItem',

        components: {
            YIcon,
            SlideUpDown,
        },

        props: {
            /**
             * Accordion Item's Id
             *
             * `required`
             */
            id: {
                type    : String,
                required: true,
            },

            /**
             * Accordion Item's Title
             */
            title: {
                type   : String,
                default: '',
            },

            /**
             * Active state of the accordion item
             */
            active: {
                type   : Boolean,
                default: false,
            },

            /**
             * Icon in close accordion
             */
            closeIcon: {
                type   : String,
                default: 'chevron-down',
            },

            /**
             * Icon in open accordion
             */
            openIcon: {
                type   : String,
                default: 'chevron-up',
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                isActive: false,
                icon    : '1',
            };
        },

        /**
         * @inheritDoc
         */
        mounted() {
            this.isActive = this.active;
            this.icon = this.$parent.icon;
        },

        methods: {
            /**
             * Toggle panel activeness.
             * return the id of the active panel with `update` event
             *
             * @public
             */
            toggleActive() {
                this.isActive = !this.isActive;

                /**
                 * Emit id of the active accordion item to the parent
                 *
                 * @event update
                 * @property {string} id of the active panel
                 */
                this.$parent.$emit('update', this.id);
            },

        },
    };
</script>
